import { branding } from '@/shared/config/branding'
import { SynapBrandLogo } from '@/shared/ui/SynapBrandLogo'
import { HeartbeatLine } from '@/widgets/login/HeartbeatLine'

interface AuthHeaderProps {
  /** Subtítulo opcional (ex.: "Crie sua conta para começar"). Quando omitido, mostra slogan da brand. */
  subtitle?: string
  /** Linha EKG abaixo do slogan, dentro do card de marca (login). */
  showHeartbeat?: boolean
}

export const AuthHeader = ({ subtitle, showHeartbeat = false }: AuthHeaderProps) => (
  <header className="space-y-4 text-center">
    <div className="mx-auto flex w-full max-w-[255px] flex-col items-center gap-3 rounded-3xl border border-[var(--color-border)] bg-white px-6 py-5 shadow-[0_12px_40px_rgba(13,42,51,0.12)]">
      <SynapBrandLogo variant="on-light" className="h-[5.25rem] w-[5.25rem]" />
      <h1
        className="text-3xl font-extrabold tracking-tight sm:text-4xl"
        style={{ color: branding.iconBrandColor }}
      >
        {branding.appName}
      </h1>
      {subtitle ? (
        <p className="text-sm font-medium text-[var(--color-text-secondary)]">
          {subtitle}
        </p>
      ) : (
        <div className="flex flex-col items-center gap-1">
          <p className="text-sm font-semibold tracking-tight text-[var(--color-text-primary)]">
            {branding.slogan}
          </p>
          <p className="text-[10px] uppercase tracking-[0.12em] text-[var(--color-text-muted)]">
            {branding.sloganSecondary}
          </p>
        </div>
      )}
      {showHeartbeat ? <HeartbeatLine embedded /> : null}
    </div>
  </header>
)
